import { defineMessages } from 'react-intl';

type MessageKeys = 'ofTotalCount' | 'loadedCount';

const message: Record<MessageKeys, { defaultMessage: string; description?: string; id: string }> =
	defineMessages({
		loadedCount: {
			id: 'paginated-picker.async-select.pagination-details.loadedCount',
			defaultMessage: '{itemsCount} results',
			description:
				'Shown in a paginated picker footer when the overall total is unknown. itemsCount is the number of results available so far.',
		},
		ofTotalCount: {
			id: 'paginated-picker.async-select.pagination-details.of-total-count',
			defaultMessage: '{itemsCount} of {totalCount}',
			description:
				'Text shown in a paginated picker indicating how many items are currently loaded versus the total available. The placeholder {itemsCount} is the number of currently visible items and {totalCount} is the total number of items.',
		},
	});

export default message;
